export default __webpack_public_path__ + "b4f943955cd54e8d81df69702500dd67.png";